'use client';

import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import DatesRange from '../../../components/lakeview/DatesRange';
import ShortGuestsSummary from '../../../components/lakeview/ShortGuestsSummary';

const DatesGuestsCard = ({ reservation }) => {
  if (!reservation) return null;

  const { startDate, endDate, guests } = reservation;

  return (
    <Card className="mb-4 border rounded p-3">
      <Row>
        <Col className="d-flex justify-content-start gap-4">
          <div className="pt-2">
            <FontAwesomeIcon
              icon={faCalendarAlt}
              size="lg"
              className="mb-1 text-neutral"
            />
          </div>
          <div>
            <div className="text-muted small text-neutral mb-2">Data</div>
            <DatesRange
              startDate={startDate}
              endDate={endDate}
              details={false}
            />
          </div>
        </Col>

        <Col className="border-start d-flex justify-content-start gap-4">
          <div className="pt-2">
            <FontAwesomeIcon
              icon={faUserFriends}
              size="lg"
              className="mb-1 text-neutral"
            />
          </div>
          <div>
            <div className="text-muted small text-neutral mb-2">Goście</div>
            <ShortGuestsSummary guests={guests} icon={false} label={false} />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default DatesGuestsCard;
